var __jsx = React.createElement;
import React from 'react';
import MuscleModal from '@modules/shared/components/modal';
import { useTranslations } from 'next-intl';
import AuthFormTemplate from '@modules/shared/auth-flows/templates/auth-form.template';
import useMuscleRouter from '@lib/hooks/use-muscle-router';
import { MuscleButton } from '@modules/shared/components/buttons';
import { useMediaQuery } from 'react-responsive';
import useViewportDimensions from '@lib/hooks/use-viewport-dimensions';
import { BREAKPOINTS } from '@lib/constants';
const ForgotPasswordEmailSentModal = _ref => {
  let {
    isOpen,
    setIsOpen,
    email,
    sendEmail,
    isSendingEmail = false
  } = _ref;
  const t = useTranslations('Shared.Auth');
  const router = useMuscleRouter();
  const isMobile = useMediaQuery({
    query: "(max-width: ".concat(BREAKPOINTS.md, "px)")
  });
  const {
    height,
    width
  } = useViewportDimensions(0.8, isMobile ? 0.7 : 0.8);
  const getHiddenEmail = () => {
    const emailSplit = email.split('@');
    const emailPartToShow = emailSplit[0].substring(0, emailSplit[0].length - 4);
    return "".concat(emailPartToShow, "****@").concat(emailSplit[1]);
  };
  const onReturnHome = () => {
    setIsOpen(false);
    router.push('/');
  };
  return __jsx(MuscleModal, {
    openState: isOpen,
    setOpenState: setIsOpen
  }, __jsx(AuthFormTemplate, null, __jsx("div", {
    className: "flex flex-col gap-2",
    style: {
      width: isMobile ? width : '384px'
    }
  }, __jsx("div", {
    className: "text-center text-black tx-plg-bold"
  }, t('PASSWORD_RECOVERY')), __jsx("br", null), __jsx("div", {
    className: "text-black  w-96 text-center tx-psm-light"
  }, "".concat(t('LINK_SENT_MESSAGE_1'), " ").concat(getHiddenEmail(), " ").concat(t('LINK_SENT_MESSAGE_2'))), __jsx("br", null), __jsx("div", {
    className: "flex flex-row items-center gap-1 text-base text-black font-thin w-96 text-center min-w-max"
  }, t('LINK_SENT_MESSAGE_3') + ' ', __jsx(MuscleButton, {
    variant: "link",
    onClick: sendEmail,
    isLoading: isSendingEmail
  }, t('RESEND_LINK'))), __jsx("br", null), __jsx(MuscleButton, {
    variant: "solidXL",
    onClick: onReturnHome,
    disabled: isSendingEmail
  }, t('RETURN_HOME')))));
};
export default ForgotPasswordEmailSentModal;